import { OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Subscription } from 'rxjs';

@Pipe({
    name: 'translate',
    pure: false
})
export class TranslatePipe implements PipeTransform, OnDestroy {
  private currentLang: string;
  private translocoSubscription: Subscription;

  constructor(private translocoService: TranslocoService) {
    this.currentLang = this.translocoService.getActiveLang();

    this.translocoSubscription = this.translocoService.langChanges$.subscribe((lang: string) => {
      this.currentLang = lang;
    });
  }

  transform(value: any, ...args: unknown[]): string {
    if (value[this.currentLang]) {
      return value[this.currentLang];
    }

    if (value['en']) {
      return value['en'];
    }

    return value['it'];

  }

  ngOnDestroy(): void {
    // Unsubscribe
    if (this.translocoSubscription) {
      this.translocoSubscription.unsubscribe();
    }
  }

}
